import { __rest } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { Field } from './Field/Field.js';
import { Help } from './Help/Help.js';
import { Label } from './Label/Label.js';
import { Message } from './Message/Message.js';
import { Root } from './styled.js';
import styles from './Form.module.css.js';

const BaseForm = React.forwardRef((_a, ref) => {
    var { gap = 16, children, className } = _a, props = __rest(_a, ["gap", "children", "className"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-form' }, props, { ref: ref, "$gap": gap, className: cn([styles['tend-ui-form-root'], className]) }), children));
});
const Form = Object.assign(BaseForm, {
    displayName: 'Form',
    Field,
    Label,
    Message,
    Help,
});

export { Form };
